import { Directive, Input, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { CommonService } from '../_services/common.service';

@Directive({
  selector: '[psiCanAccess]'
})
export class CanAccessDirective {

  @Input('psiCanAccess') psiCanAccess: string;
  
  constructor(private commonService: CommonService, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) { }

  ngOnInit():void{
    this.checkPermission();
  }

  private checkPermission():void{
    if(this.psiCanAccess){
      let authorize = this.commonService.checkPermission(this.psiCanAccess);
      this.viewContainer.clear();
      if(!authorize){
        this.viewContainer.clear();
      }else{
        //console.log("keep it " + this.psiCanAccess);
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
  }
}
